import { Badge } from 'components/ui/badge';
import { cn } from 'lib/utils';
import { useTranslation } from 'react-i18next';
import { AccessTier } from 'services/api/models/UserDTO';
import PatientAccessTierIcon from './PatientAccessTierIcon';

const ACCESS_TIER_LABEL_KEYS: Record<AccessTier, string> = {
  LICENSE_CODE: 'chats.caregiverStatus.licenseCode',
  APP_SUBSCRIPTION: 'chats.caregiverStatus.paidSubscription',
  FREE: 'chats.caregiverStatus.freeTrial',
};

type PatientAccessTierTagProps = {
  accessTier: AccessTier;
  className?: string;
};

export default function PatientAccessTierTag({ accessTier, className }: PatientAccessTierTagProps) {
  const { t } = useTranslation();

  return (
    <Badge variant="secondary" className={cn('[&_.anticon]:text-xs', className)}>
      <PatientAccessTierIcon accessTier={accessTier} />
      {t(ACCESS_TIER_LABEL_KEYS[accessTier])}
    </Badge>
  );
}
